import {Injectable} from '@angular/core';
import {Actions, Effect, ofType} from '@ngrx/effects';

import {catchError, exhaustMap, map, switchMap} from 'rxjs/operators';
import {of} from 'rxjs';


import {Observable} from 'rxjs';
import {
  DigitalWalletActions,
  DigitalWalletActionTypes,
  // DisableDigitalWalletFailure,
  // DisableDigitalWalletSuccess,
  // EnableDigitalWalletFailure,
  // EnableDigitalWalletSuccess,
  LoadDigitalWalletFailure,
  LoadDigitalWalletSuccess
} from '../actions/digitalwallet.actions';
import {AuthService} from '../services/auth.service';
import {CurrentUserModel} from '../models/account-ledger.model';
import {CheckOutService} from '../services/checkout.service';
import {CommonService} from '../services';
import {DickerSelectListItem} from '../models/check-out.model';

@Injectable()
export class DigitalWalletEffects {
  @Effect()
  loadDigitalWallet$: Observable<DigitalWalletActions> = this.actions$.pipe(
    ofType(DigitalWalletActionTypes.Load),
    exhaustMap(() => this.authService.getLoginInfo().pipe(
      switchMap((currentUserModel: CurrentUserModel) => {
        let customerPayments$: Observable<DickerSelectListItem[]>;
        if (currentUserModel.hasAdminAccess) {
          customerPayments$ = this.checkOutService.GetSubscriptionDigitalWallet();
        } else if (currentUserModel.hasPurchaseAccess) {
          customerPayments$ = this.checkOutService.GetSubscriptionDigitalWallet(currentUserModel.loginId);
        } else {
          customerPayments$ = of([]);
        }
        return customerPayments$.pipe(
          map((customerPayments) => {
            return new LoadDigitalWalletSuccess(customerPayments);
          }),
          catchError(error => of(new LoadDigitalWalletFailure(error)))
        );
      }),
    ))
  );

  // @Effect()
  // enableDigitalWallet$: Observable<DigitalWalletActions> = this.actions$.pipe(
  //   ofType(DigitalWalletActionTypes.Enable),
  //   switchMap((action: any) => {
  //     return this.checkOutService.EnablePaywayCustomer(action.payload).pipe(
  //       map((res: ApiResponse) => {
  //         if (res && res.status) {
  //           this.commonService.implementToast('Future payments has been enabled successfully', 'Success');
  //           return new EnableDigitalWalletSuccess(action.payload);
  //         } else {
  //           this.commonService.implementToast('Enable Payway Customer Failed', 'Error');
  //           return new EnableDigitalWalletFailure();
  //         }
  //       }),
  //       catchError(error => {
  //         this.commonService.implementToast('Enable Payway Customer Failed', 'Error');
  //
  //         return of(new EnableDigitalWalletFailure());
  //       })
  //     );
  //   }),
  // );
  //
  // @Effect()
  // disableDigitalWallet$: Observable<DigitalWalletActions> = this.actions$.pipe(
  //   ofType(DigitalWalletActionTypes.Disable),
  //   switchMap((action: any) => {
  //     return this.checkOutService.DisablePaywayCustomer(action.payload).pipe(
  //       map((res: ApiResponse) => {
  //         if (res && res.status) {
  //           this.commonService.implementToast('Future payments has been disabled successfully', 'Info');
  //
  //           return new DisableDigitalWalletSuccess(action.payload);
  //         } else {
  //           this.commonService.implementToast('Disable Payway Customer Failed', 'Error');
  //
  //           return new DisableDigitalWalletFailure();
  //         }
  //       }),
  //       catchError(error => {
  //         this.commonService.implementToast('Disable Payway Customer Failed', 'Error');
  //         return of(new DisableDigitalWalletFailure());
  //       })
  //     );
  //   }),
  // );

  constructor(
    private actions$: Actions,
    private authService: AuthService,
    private checkOutService: CheckOutService,
  ) {
  }
}
